import { viperApi, clinicalApiPath } from '@/services/viper-api'
import * as qs from 'qs'

export const patientSearchService = {
  basePath: organizationId => `${clinicalApiPath}/organizations/${organizationId}/patient-search`,

  search(organizationId, params) {
    return viperApi.get(this.basePath(organizationId), {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, {})
      }
    })
  }
}
